module.exports = __webpack_public_path__ + "assets/9128488ffb758f16e0ebc4786a1085f9.png";